let EthType;
let CosmosType;
let ledgerServiceType;
let TransportWebUSB;
let TransportWebHID;
export async function loadEthType() {
    if (!EthType) {
        const module = await import('@bangjelkoski/ledgerhq-hw-app-eth');
        EthType = module.Eth ? module.Eth : module.default.Eth;
    }
    return EthType;
}
export async function loadCosmosType() {
    if (!CosmosType) {
        const module = await import('@bangjelkoski/ledgerhq-hw-app-cosmos');
        CosmosType = module.Cosmos ? module.Cosmos : module.default.Cosmos;
    }
    return CosmosType;
}
export async function loadLedgerServiceType() {
    if (!ledgerServiceType) {
        const module = await import('@bangjelkoski/ledgerhq-hw-app-eth');
        ledgerServiceType =
            module.ledgerService ||
                module.default.ledgerService;
    }
    return ledgerServiceType;
}
export async function loadTransportWebUSB() {
    if (!TransportWebUSB) {
        const module = await import('@bangjelkoski/ledgerhq-hw-transport-webusb');
        TransportWebUSB =
            module.TransportWebUSB ||
                module.default.TransportWebUSB;
    }
    return TransportWebUSB;
}
export async function loadTransportWebHIDType() {
    if (!TransportWebHID) {
        const module = await import('@bangjelkoski/ledgerhq-hw-transport-webhid');
        TransportWebHID =
            module.TransportWebHID ||
                module.default.TransportWebHID;
    }
    return TransportWebHID;
}
